import { reactive } from 'vue';
import { createInjection } from 'src/lib/createInjection';
import userApi from 'src/apis/user';
import type { UserLoginParams } from 'src/models/apis/user/userRequest';
import type {
  User,
  UserLogin,
  UserLogout,
} from 'src/models/user';

type AuthContext = {
  user: User | null;
  login: (credentials: UserLoginParams) => Promise<UserLogin>;
  logout: () => Promise<UserLogout>;
};

type ProvideAuthResult = {
  userResolved: () => Promise<User>;
};

const { provide, inject } = createInjection<AuthContext>('useAuth');

export function provideAuth(): ProvideAuthResult {
  const authContext = reactive<AuthContext>({
    user: null,
    // ログインはフルリロード（location.href）後の getMe で user を確定させるため、
    // ここでは user をセットしない（二要素認証分岐ではそもそも user が返らない）
    login: async(credentials: UserLoginParams): Promise<UserLogin> => {
      return await userApi.login(credentials);
    },
    logout: async(): Promise<UserLogout> => {
      const result = await userApi.logout();
      authContext.user = null;
      return result;
    },
  });

  const userResolved = async(): Promise<User> => {
    const currentUser = await userApi.getMe();
    authContext.user = currentUser;
    return currentUser;
  };

  provide(authContext);

  return { userResolved };
}

export function useAuth(): AuthContext {
  return inject();
}
